import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MainRoute } from '../../app';
import { UserRoute } from '../user/userContainer';

/**
 * Intuit opens this page (the app's Disconnect URL) when someone disconnects RoboDebit
 * from inside QuickBooks. It says what that means and how to reconnect.
 */
const DisconnectedPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      flexDirection="column"
      p={4}
      border="1px solid #ddd"
      borderRadius="8px"
      maxWidth="480px"
      margin="10% auto"
      boxShadow="0px 4px 12px rgba(0, 0, 0, 0.1)"
    >
      <Typography variant="h5" gutterBottom>
        RoboDebit is disconnected from QuickBooks
      </Typography>
      <Typography variant="body1" paragraph>
        RoboDebit can no longer read from or post to this QuickBooks company. Scheduled journal entries for it stop
        until you reconnect. Your templates and posting history are kept.
      </Typography>
      <Typography variant="body1" fontWeight={600} gutterBottom>
        To reconnect
      </Typography>
      <Box component="ol" sx={{ mt: 0, pl: 3 }}>
        <li>Sign in to RoboDebit.</li>
        <li>Open Clients.</li>
        <li>Click Connect to QuickBooks next to the company, and sign in to QuickBooks to approve the connection.</li>
      </Box>
      <Typography variant="body2" color="textSecondary" paragraph>
        Didn&apos;t mean to disconnect, or need help? Email{' '}
        <a href="mailto:support@robodebit.com">support@robodebit.com</a>.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate(MainRoute.User + UserRoute.Clients)}>
        Sign In to Reconnect
      </Button>
    </Box>
  );
};
export default DisconnectedPage;
